// extracted by mini-css-extract-plugin
export default {"base":"base-PKZgS","description":"description-wVYXR","left":"left-EUWjj","right":"right-tjcA5","list":"list-qBIDN","images":"images-Y64Nu"};